var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getWinWidth, getWinHeight, isFunction, getElementAs, isEmpty, isString } from 'cobrowse-common/modules/utils';
import { pushJSONToForm } from 'cobrowse-common/modules/formHelpers';
import { LoginControl } from 'cobrowse-common/components/loginControl';
import { clientError, Monitoring } from '../components/monitoring';
export const isHTML5Supported = () => {
    try {
        const validationPassed = 'postMessage' in window
            && 'addEventListener' in window
            && 'JSON' in window
            && 'history' in window
            && 'pushState' in window.history
            && 'keys' in Object
            && 'forEach' in Array.prototype
            && 'indexOf' in Array.prototype
            && 'performance' in window
            && 'now' in window.performance;
        if (!validationPassed) {
            return false;
        }
        const elem = document.createElement('canvas');
        return isFunction(elem === null || elem === void 0 ? void 0 : elem.getContext) && !isEmpty(elem.getContext('2d'));
    }
    catch (e) {
        return false;
    }
};
window.addEventListener('load', () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const form = getElementAs('t');
    const ratio = (_a = window.devicePixelRatio) !== null && _a !== void 0 ? _a : 1;
    const dynamicParams = {
        ll_user_agent: navigator.userAgent,
        ll_screen_width: `${screen.width * ratio}`,
        ll_screen_height: `${screen.height * ratio}`,
        ll_java_enabled: `${navigator.javaEnabled()}`,
        ll_cookies_enabled: `${navigator.cookieEnabled}`
    };
    const sizeX = getWinWidth();
    const sizeY = getWinHeight();
    const zeroWindowSize = (sizeX === 0 && sizeY === 0);
    if (isHTML5Supported()) {
        dynamicParams.ll_html5_enabled = 'yes';
    }
    if (zeroWindowSize) {
        dynamicParams.ll_zero_size = zeroWindowSize.toString();
    }
    if ((_b = document) === null || _b === void 0 ? void 0 : _b.documentMode) {
        dynamicParams.ll_doc_mode = document.documentMode.toString();
    }
    if (isString(document === null || document === void 0 ? void 0 : document.compatMode)) {
        dynamicParams.ll_comp_mode = document.compatMode;
    }
    if (loginRequired) {
        Monitoring.configure(debugLevel, requestParams.sessionID);
        try {
            LoginControl.configure({
                uiConfig: uiMessages
            });
            dynamicParams.jwt = yield LoginControl.authenticate("agent", luserRequest);
        }
        catch (ex) {
            clientError(`Authentication failed with ${ex}`);
            console.error(ex);
            throw ex;
        }
    }
    pushJSONToForm(form, dynamicParams);
    form.submit();
}), false);
